import * as React from "react";
import {
	LibraryCard,
	CardType,
	CardPropertyType,
} from "../../../../types/LibraryCard";
import MobileBookSection from "../../MobileBookSection/MobileBookSection";
import cn from "classnames";
import "./BooksSection.css";
import Button from "../../../Button/Button";
import { useHistory } from "react-router-dom";
import Card from "../../../Feed/Card/Card";
import { getDatePeriod } from "../../../../utils";

interface Props {
	books: LibraryCard[];
	header: string;
	bookShowType: "standart" | "mini";
	emptyText?: React.ReactNode;
	type?: string;
}

const BookSection: React.FC<Props> = (props) => {
	const history = useHistory();

	return (
		<MobileBookSection
			header={props.header}
			moreText={
				props.books.length > 0 && (
					<Button onClick={() => history.push(`/${props.type}`)}>
						Открыть все
					</Button>
				)
			}
		>
			<div>
				{props.books.length > 0 && (
					<div
						className={cn("mobile-books__books__wrapper", {
							"mobile-books__books__wrapper_mini": props.books.length > 1,
						})}
					>
						{props.books.map((book) => {
							return (
								<Card
									book={{
										...book.book,
										card: {
											id: book.eId,
											type: book.cardType,
										},
									}}
									fullWidth={props.books.length === 1}
									date={
										book.cardType === CardType.ReadNow ||
											book.cardType === CardType.WantRead
											? getDatePeriod(
												book.properties[CardPropertyType.DateBegin],
												null,
												'c ',
												null,
												book.cardType === CardType.WantRead
											  )
											: null
									}
									flatCategory={true}
									hiddenCheckIcon={true}
								/>
							);
						})}
					</div>
				)}

				{props.books.length === 0 && props.emptyText && (
					<div className="mobile-books__books__wrapper__empty">
						{props.emptyText}
					</div>
				)}
			</div>
		</MobileBookSection>
	);
};

export default BookSection;
